'use strict';

import Xhr from '../libs/xhr';

// global variables
window.store = {
    selectedEventType: null,
    persons: null,
    percentages: null,
    wineOffer: null,
    calculateTriggered: 0,
    bottles: {
        alb: null,
        roze: null,
        rosu: null,
        spumant: null
    },
    bottlesTotal: null,
    eventTypes: {},
    finalOrder: [],
    userSelection: {
        tabs: {},
        selectedTab: 'Low'
    },
    samplesList: {}
};

class WineRepository {
    constructor() {
        this.params = {
            jsonUrl: '/calculator-data'
        };

        this.getWinesAndRatios()
            .then(() => {
                // this.populateWines('type1');
            })
            .catch(e => {
                this.showError();
            });
        
        this.initTabsClickEvent();
    }

    showError() {
        $('.js-content-start').html(
            `<h2 class="color-brand">
                Ne pare rău!<br>
                Calculatorul este momentan indisponibil.
            </h2>
            <h4 class="text-center">Vă rugăm să reveniți mai târziu</h4>
            <p>&nbsp;</p>`
        );
    }

    // ajax get of data
    getWinesAndRatios() {
        return new Promise((resolve, reject) => {
            let options = {
                type: 'GET',
                url: this.params.jsonUrl,

                data: {},

                success: data => {
                    store.percentages = data.percentages;
                    store.wineOffer = data.data;
                    resolve();
                },

                error: function(xhr) {
                    reject(xhr.responseJson);
                }
            };

            let xhr = new Xhr();
            xhr.setOptions(options);
            xhr.execute();
        });
    }

    // render wines in page
    populateWines() {
        // console.log('[populateWines] => populating wines...');

        let type = store.selectedEventType;

        // curat vinurile HTML inainte de a popula
        for (let wineType in store.wineOffer['type1']['budgetLow']) {
            $(`.js-${wineType}`).html('');
        }

        // populez viurile noi
        for (let budget in store.wineOffer[type]) {
            if (!store.wineOffer[type].hasOwnProperty(budget)) {
                return;
            }
            let wines = store.wineOffer[type][budget];

            for (let wineType in wines) {
                if (!wines.hasOwnProperty(wineType)) {
                    return;
                }

                let wineTypeWines = wines[wineType];
                let winesHtml = '';

                for (let i = 0; i < wineTypeWines.length; i++) {
                    let wine = wineTypeWines[i];
                    wine.budget = budget;
                    wine.type = wineType;

                    let wineProduct = this.buildProductHTML(wine);
                    winesHtml += wineProduct;
                }

                $(`.js-${budget} .js-${wineType}`).append(winesHtml);
            }
        }
    }

    // HELPER - genereaza HTML pentru un produs
    buildProductHTML(wine) {
        let selectedClass = wine.selected === true ? 'selected' : '';
        let priceFormatted = wine.price > 0 ? (wine.price + ' RON / sticlă') : '<bold>indisponibil</bold>';
        return `
            <div class="calc-product js-product ${selectedClass}" data-id="${wine.id}" data-type="${wine.type}" data-price="${wine.price}">
                <img src="${wine.image}" alt="${wine.name}" class="calc-product__image">
                <div class="calc-product__data">
                    <div class="calc-product__series-title">
                        ${wine.range}
                    </div>
                    <h3>
                        ${wine.name}
                    </h3>
                    <div class="calc-product__details">
                        ${wine.description}
                    </div>
                    <div class="calc-product__price">
                        ${priceFormatted}
                    </div>
                </div>
            </div>
        `;
    }

    initTabsClickEvent() {
        $('.js-tabs').find('.js-tab-link').on('click', function() {
            window.store.userSelection.selectedTab = $(this).data('type');
        });
    }

    sendOrder() {
        // console.log('sending order');
        return new Promise((resolve, reject) => {
            let options = {
                url: this.params.jsonUrl,
                data: {
                    userSelection: {
                        selectedEventType: window.store.selectedEventType,
                        persons: window.store.persons,
                        bottles: window.store.bottles,
                        bottlesTotal: window.store.bottlesTotal,
                        ...window.store.userSelection
                    },
                    data: store.finalOrder
                },
                dataType: 'json',
                beforeSend: function() {},

                success: data => {
                    window.location.href = data.redirect_url;
                },

                error: function(xhr) {
                    reject(xhr.responseJson);
                }
            };

            let xhr = new Xhr();
            xhr.setOptions(options);
            xhr.execute();
        });
    }
}

// ========================================================================================================
// ========================================================================================================
// ========================================================================================================

class Calculator {
    constructor(wineRepository) {
        this.wineRepository = wineRepository;
        this.selectors = {
            contentStart: '.js-content-start',

            // elements for bottle estimator
            wrapperBottles: '.js-estimated-bottles-wrapper',
            totalBottles: '.js-estimated-bottles-total',
            albBottles: '.js-estimated-bottles-alb',
            rozeBottles: '.js-estimated-bottles-roze',
            rosuBottles: '.js-estimated-bottles-rosu',
            spumantBottles: '.js-estimated-bottles-spumant',
            resultBottles: '.js-result-bottles',
            productItem: '.js-product',

            // elements for budget list
            wrapperBudget: '.js-offer-wrapper',

            eventSelector: '.js-event-selector',
            eventPersons: '.js-event-persons',
            initEstimate: '.js-estimate-init',
            budgetFooter: '.js-tab-content',
            budgetFooterEventType: '.js-footer-event-type',
            budgetFooterPersons: '.js-footer-persons',
            initOrder: '.js-order-init',

            // elements for samples
            wrapperSamples: '.js-samples-wrapper',
            sampleItem: '.js-sample',
            initOrderSamples: '.js-order-samples-init',
            orderSamplesError: '.js-order-samples-error'
        };

        this.eventTypeRadios = $(this.selectors.eventSelector).find(
            "input[name='eventType']"
        );

        this.resetForm();
        this.observeInputs();

        // executie click pe calculeaza
        $(this.selectors.initEstimate).on('click', () => {
            // console.log('[Calculator] => Calculate button clicked');
            store.calculateTriggered = 1;

            this.wineRepository.populateWines();
            this.calculateBottles();
            this.showEstimatedBottles();
            this.toggleProducts();
            this.populateFooter();

            this.calculateSamples();
            this.updateSamplePrices();
            this.toggleSamples();
            // this.makeSamplesList();
        });

        $(this.selectors.initOrder).on('click', e => {
            e.preventDefault();
            this.initOrder(e);
            this.wineRepository.sendOrder();
        });

        $(this.selectors.initOrderSamples).on('click', e => {
            e.preventDefault();

            let selectedSamples = $(`${this.selectors.sampleItem}.selected`);

            if (selectedSamples.length > 0) {
                this.initOrderSampleBoxes();
                this.wineRepository.sendOrder();
                $(this.selectors.orderSamplesError).slideUp();
            } else {
                $(this.selectors.orderSamplesError).slideDown();
            }
        });
    }

    resetForm() {
        $(document).ready(() => {
            $(this.eventTypeRadios).each((index, radio) => {
                $(radio).prop('checked', false);
            });
            $(this.selectors.eventPersons).val('');
        });
    }

    // valiare la ce a selectat inainte de a da submit
    observeInputs() {
        // console.log('[observeInputs] => Observing inputs...');

        let eventsType = this.eventTypeRadios;
        let personsInput = $(this.selectors.eventPersons);
        let personsNumber = null;
        let checkedEventType = null;

        let validateInputs = () => {
            checkedEventType = $(this.selectors.eventSelector).find(
                'input[name="eventType"]:checked'
            );
            personsNumber = personsInput.val().trim();
            if(personsNumber <= 0 || personsNumber > 3000) {
                personsNumber = 0;
            }

            if (
                personsNumber === '' ||
                personsNumber == 0 ||
                checkedEventType.length === 0
            ) {
                $(this.selectors.initEstimate)
                    .prop('disabled', true)
                    .attr('disabled', 'disabled');
                return;
            }

            store.checkedEventType = checkedEventType.val();
            store.persons = personsNumber;

            $(this.selectors.initEstimate)
                .prop('disabled', false)
                .removeAttr('disabled');
        };

        eventsType.on('change', validateInputs);
        personsInput.on('input', validateInputs);

        // daca da click pe un tip de eveniment reinitializez calculele
        eventsType.on('click', e => {
            store.selectedEventType = $(e.currentTarget).val();
            store.persons = personsNumber;
            // console.log('[observeInputs] => Event type clicked]');

            // verific daca inputul de persoane are valoare valida si daca butonul calculeaza a fost apasat macar o data
            if (personsNumber > 0 && store.calculateTriggered === 1) {
                validateInputs();
                this.wineRepository.populateWines();
                $(this.selectors.initEstimate).trigger('click');
                // this.toggleProducts();
            }
        });
    }

    // calculeaza necesarul de sticle
    calculateBottles() {
        // console.log('==============================');
        // console.log('Selected Event: ' + store.selectedEventType);
        // console.log('Total persons = ' + store.persons);
        // console.log('==============================');
        // console.log('Calculating bottles...');
        // se foloseste eval pentru a calcula procentul din format uman 1/12 = 1 sticla la 12 persoane)
        let amountTemp = Math.ceil(
            store.persons *
                eval(store.percentages[store.selectedEventType]['wineRatio'])
        );
        // console.log('Calculated temp Bottles = ' + amountTemp);

        function percentage(percent, value) {
            return Math.ceil((value / 100) * percent);
        }

        // evaluez procentajul de sticle pentru fiecare tip de vin
        let percentageAlb = eval(
            store.percentages[store.selectedEventType]['alb']
        );
        let percentageRoze = eval(
            store.percentages[store.selectedEventType]['roze']
        );
        let percentageRosu = eval(
            store.percentages[store.selectedEventType]['rosu']
        );

        store.bottles.alb = percentage(percentageAlb, amountTemp);
        // console.log('Vin alb = ' + store.bottles.alb);

        store.bottles.roze = percentage(percentageRoze, amountTemp);
        // console.log('Vin roze = ' + store.bottles.roze);

        store.bottles.rosu = percentage(percentageRosu, amountTemp);
        // console.log('Vin rosu = ' + store.bottles.rosu);

        store.bottles.spumant = Math.ceil(
            store.persons *
                eval(store.percentages[store.selectedEventType]['spumantRatio'])
        );
        // console.log('Vin spumant = ' + store.bottles.spumant);

        store.bottlesTotal =
            store.bottles.alb +
            store.bottles.roze +
            store.bottles.rosu +
            store.bottles.spumant;
        // console.log('Total sticle = ' + store.bottlesTotal);

        // writing values into html
        $(this.selectors.totalBottles).text(store.bottlesTotal);
        $(this.selectors.albBottles).text(store.bottles.alb);
        $(this.selectors.rozeBottles).text(store.bottles.roze);
        $(this.selectors.rosuBottles).text(store.bottles.rosu);
        $(this.selectors.spumantBottles).text(store.bottles.spumant);

        // this.showEstimatedBottles();

        // efect vizual in cazul recalcularii necesarului de sctile
        let resultBottlesList = this.selectors.resultBottles;
        if (!$(resultBottlesList).hasClass('transition')) {
            $(resultBottlesList).addClass('transition');

            setTimeout(() => {
                $(resultBottlesList).removeClass('transition');
            }, 500);
        } else {
            $(resultBottlesList).removeClass('transition');
        }
    }

    // afisez pe site numariul de sticle necesare si tab-urile
    showEstimatedBottles() {
        $(this.selectors.wrapperBottles).slideDown();
        $(this.selectors.wrapperBudget).slideDown();
        $(this.selectors.wrapperSamples).slideDown({
            start: function() {
                $(this).css({
                    display: 'flex'
                });
            }
        });
        this.calculatePrices();
    }

    // schimba starea de selected pe produse
    toggleProducts() {
        let self = this;
        $(this.selectors.productItem).on('click', function() {
            if ($(this).hasClass('selected')) {
                return;
            }

            // schimb starea de selected
            $(this)
                .addClass('selected')
                .siblings()
                .removeClass('selected');

            // aflu pe ce tab sunt
            let activeTab = $(this)
                .parents('.js-tab-content')
                .data('type');

            self.calculatePrices(activeTab);
        });
    }

    toggleSamples() {
        let self = this;
        $(this.selectors.sampleItem).each((index, sampleBox) => {
            $(sampleBox).on('click', () => {
                $(sampleBox).toggleClass('selected');
            });
        });
    }

    // calculez preturile pentru fiecare buget in parte

    calculatePrices(budgetContainer = null) {

        // setez daca calculez toate taburile in urma unui schimb la tipul de evenimente sau nr persoane
        // sau calculaz doar tab-ul selectat in urma selectarii altor produse in tab-ul respectiv
        let calculateTabOnly = false;

        if (budgetContainer === null) {
            budgetContainer = '.js-tab-content';
        } else {
            calculateTabOnly = true;
            budgetContainer = `[data-type=${budgetContainer}]`;
        }

        // console.clear();
        // console.log('==================');
        // console.log('calculez pret pentru ' + budgetContainer);

        $(budgetContainer).each((index, budgetDiv) => {
            let budgetType = $(budgetDiv).data('type');

            // reset user selection for this tab
            window.store.userSelection.tabs[budgetType] = [];

            let unitPrice = null;
            let type = null;
            let price = {
                alb: null,
                roze: null,
                rosu: null,
                spumant: null
            };

            // aflu produsul selectat per tipul de vin, ii calculez pretul si il salvez in store
            $(budgetDiv)
                .find('.selected')
                .each((index, selectedWineElement) => {
                    selectedWineElement = $(selectedWineElement);
                    unitPrice = parseInt(selectedWineElement.data('price'), 10);
                    type = selectedWineElement.data('type');
                    price[type] = store.bottles[type] * unitPrice;

                    window.store.userSelection.tabs[budgetType].push({
                        id: selectedWineElement.data('id'),
                        quantity: store.bottles[type],
                        price: unitPrice
                    });
                });

            let minPrice = 0;
            let totalPrice =
                price.alb + price.roze + price.rosu + price.spumant;

            // afisez pretul minim calculat un butonul tab-ului (de la....)
            if (!calculateTabOnly) {
                minPrice = totalPrice;
                $(`[data-estimated${budgetType}]`).text(minPrice);
            }

            // afisez pretul final in footerul fiecarui tab
            $(`[data-finalprice${budgetType}]`).text(totalPrice);

            // console.log('--- de la ' + budgetType + ' = ' + minPrice);
            // console.log('--- TOTAL ' + budgetType + ' = ' + totalPrice);
        });
    }

    // afisez in footer tipul de eveniment si numarul de persoane
    populateFooter() {
        let self = this;

        // parsez obiectul de procentaje pentru a scoate numele evenimentelor
        for (let key in store.percentages) {
            store.eventTypes[key] = store.percentages[key]['name'];
        }

        // gasesc id-ul tipului de eveniment
        let checkedEventType = $(this.selectors.eventSelector)
            .find('input[name="eventType"]:checked')
            .attr('id');

        // aflu textul tipului de eveniment
        let footerEventType = store.eventTypes[checkedEventType];
        footerEventType = footerEventType.replace(/<br>/g, ' / ');

        // setez tipul de eveniment in footer
        $(this.selectors.budgetFooter).each(function(index) {
            $(this)
                .find(self.selectors.budgetFooterEventType)
                .html(footerEventType);
        });

        // afisez numarul de persoane in footer
        $(this.selectors.budgetFooterPersons).html(store.persons);
    }

    initOrder(event) {
        // console.log(event);
        let activeTab = $(event.currentTarget).parents('.js-tab-content');
        let selectedProducts = activeTab.find('.js-product.selected');
        let clickedButton = event.target;

        store.finalOrder[0] = {
            budget: $(clickedButton).data('budget'),
            sample: $(clickedButton).data('sample'),
            products: []
        }

        // console.log('calculating final order');

        selectedProducts.each((index, item) => {
            let type = $(item).data('type');
            let id = $(item).data('id');
            let amount = store.bottles[type] || 0;

            store.finalOrder[0].products.push({
                id: id,
                amount: amount
            });
        });

        // console.log(store.bottles);
        // console.log(store.finalOrder);
    }

    initOrderSampleBoxes() {
        let selectedSamples = $(`${this.selectors.sampleItem}.selected`);

        selectedSamples.each((index, sampleItem) => {
            // console.log(index);
            // console.log(store.finalOrder);
            let budgetType = $(sampleItem).data('budget');
            store.finalOrder[index] = {
                budget: budgetType,
                sample: $(sampleItem).data('sample'),
                products: []
            }

            let selectedProducts = store.samplesList[budgetType]['productList'];

            // console.log(selectedProducts);

            selectedProducts.forEach(itemId => {
                let id = itemId;
                let amount = 1;

                store.finalOrder[index].products.push({
                    id: id,
                    amount: amount
                });
            });
        });
        // console.log(store.finalOrder);
    }

    calculateSamples() {
        // console.log('[calculateSamples] => calculating salmples list');
        let tabs = $('.js-tab-content');

        tabs.each((index, tab) => {
            // console.log('tab' + index);
            let tabProducts = $(tab).find('.js-product');
            let tabType = $(tab).data('type');

            let productCount = tabProducts.length;

            store.samplesList[tabType] = {};
            store.samplesList[tabType]['productList'] = [];
            let samplePrice = 0;

            tabProducts.each((productIndex, product) => {
                let productPrice = $(product).data('price');
                if (productIndex < productCount - 1) {
                    let id = $(product).data('id');
                    store.samplesList[tabType]['productList'].push(id);
                    samplePrice += productPrice;
                }
            });
            samplePrice = samplePrice.toFixed(2);
            
            store.samplesList[tabType]['totalPrice'] = samplePrice;
        });
    }

    updateSamplePrices() {
        let sampleItems = $(this.selectors.sampleItem);

        sampleItems.each((index, sampleBox) => {
            let sampleBudget = $(sampleBox).data('budget');
            let samplePrice = store.samplesList[sampleBudget]['totalPrice'];
            $(sampleBox)
                .find('.js-samplebox-price')
                .text(samplePrice);
        });
    }
}

// {
//     bottles: {
//         alb: {
//             id: 23,
//             bottles: 7,
//             bottlePrice: 15
//         }
//     }
// }

let wRepo = new WineRepository();
let calculator = new Calculator(wRepo);
